<div class="container mt-5 mb-5">
  <div class="row mb-5">
    <div
      class="col-12 d-inline-block d-flex flex-column choose-plan-title-wrapper"
    >
      <h2 class="choose-plan-title text-center">With our lost & found cover you can act immediately – and with our premium plans over 70% of pets are returned home safely</h2>
    </div>
  </div>
  <div class="row mb-3 mt-5">
    <div class="col-12">
      <app-fixed-pricing-table
        *ngIf="!isAuthenticated || (isAuthenticated && user)"
        [viewOnly]="true"
        [showShortDescription]="true"
        [buttonLabel]="'Learn more'"
        [pricingPlans]="pricingPlans"
        [hidePrices]="true"
        (onSelect)="select($event)"
        [showWideIdentiAlertCard]="true"
        [hideIcons]="true"
        [hasBuyNow]="true"
        [appPriceCardFeatureText]="appPriceCardFeatureText"
        [showPeachBanner]="true"
        [user]="user"
      >
      </app-fixed-pricing-table>
    </div>
  </div>
</div>
